// extracted by mini-css-extract-plugin
module.exports = {"imgContainer":"index_imgContainer__L5DRy","rotate":"index_rotate___q28b","spin":"index_spin__caoIu","icon":"index_icon__tjhkH"};